export default __webpack_public_path__ + "static/media/intro_selfimage.a3736b3a.png";